import { withSvgIcon } from './withSvgIcon';

export const ChatIcon = withSvgIcon(
  <>
    <path
      d="M4 20L6.44373 17.9636C6.71901 17.7342 6.85665 17.6195 7.02162 17.5597C7.1866 17.5 7.36576 17.5 7.7241 17.5H18C18.9428 17.5 19.4142 17.5 19.7071 17.2071C20 16.9142 20 16.4428 20 15.5V7.5C20 6.55719 20 6.08579 19.7071 5.79289C19.4142 5.5 18.9428 5.5 18 5.5H6C5.05719 5.5 4.58579 5.5 4.29289 5.79289C4 6.08579 4 6.55719 4 7.5V20Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M7 10L17 10" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7 13L12 13" stroke="currentColor" strokeWidth="1.5" />
  </>,
  { viewBox: '0 0 24 24' },
);
